"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _ramdaAdjunct = require("ramda-adjunct");

var _default = function _default() {
  var keyNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var predicate = arguments.length > 1 ? arguments[1] : undefined;
  var obj = arguments.length > 2 ? arguments[2] : undefined;

  if ((0, _ramdaAdjunct.isNotFunction)(predicate)) {
    return (0, _ramdaAdjunct.isNotNilOrEmpty)(obj) ? (0, _ramda.pick)(keyNames)(obj) : (0, _ramda.pick)(keyNames);
  }

  var composedFn = (0, _ramda.compose)((0, _ramda.pickBy)(predicate), (0, _ramda.pick)(keyNames));
  return (0, _ramdaAdjunct.isNotNilOrEmpty)(obj) ? composedFn(obj) : composedFn;
};

exports.default = _default;